module.exports = __webpack_public_path__ + "fonts/Raleway-LightItalic.6446cb56.ttf";